module.exports = __webpack_public_path__ + "media/SetB_T6_A.f7586a70.mp3";